module.exports = __webpack_public_path__ + "img/feuille.cc6d83dc.svg";